export default {
  login: { method: "post", url: "api/auth/login" },
  logout: { method: "post", url: "api/auth/logout" },
  loadSession: { method: "get", url: "api/auth/me" },
  refresh: { method: "post", url: "api/auth/refresh" },
  forgotPassword: { method: "post", url: "api/auth/forgot-password" },
  resetPassword: { method: "post", url: "api/auth/reset-password" },
};
